import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class FileService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.FILE_STORAGE = '/api/file-storage';
        this.FILE_CLOB = '/api/file-clob';

        this.GET_BY_ID = '/{id}';
        this.GET_BY_TABLE_AND_ITEM_ID = '/table/{tableType}/item/{itemId}';
        this.GET_S3_FILES_BY_TABLE_AND_ITEM_ID = '/s3/table/{tableType}/item/{itemId}';
        this.GET_AND_UPLOAD_EXISTING_FILE_IN_S3 = "/get/file-clob/upload/s3";
        this.GET_FILE_BY_FILENAME_AND_TABLE_AND_ITEM_ID = '/file/{fileName}/table/{tableType}/item/{itemId}';
        this.RENAME_FILE = "/rename/file";
        this.DELETE_FILE_IN_STORAGE = '/delete/file';
        this.DELETE_FILE_IN_STORAGE_PERMANENT = '/delete/file/permanent';
        this.ADD_FILE_IN_STORAGE = '/add/file';
        this.ADD_FILE_AND_GENERATE_URL = '/add/file/generate/url';
        this.DELETE_FILE_BY_ID = '/id';

        this.CREATE_FILE_STORAGE_FOR_LEADS = "/leads/create/uploads";
        this.DELETE_FILE_STORAGE_FOR_LEADS = "/leads/delete/uploads";

    }

    async getFile(id) {
        try {
            let url = window.location.origin + this.FILE_CLOB + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async createFile(fileMap) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_CLOB;
            const fileDataRet = await this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(fileMap)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async createFileForLeads(fileMap) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.CREATE_FILE_STORAGE_FOR_LEADS;

            const fileAdded = await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(fileMap)
            })
            .then(data => data.json())
            .then(data => {
                if(data.error !== undefined){
                    if(data.error === 'Session Expired') {
                        let userAuthService = new UserAuthService();
                        userAuthService.logout();
                    } else {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                }
                return data;
            });

            return fileAdded;

        } catch (err) {
            console.log(err);
        }
    }

    async renameFileName(bodyObj) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.RENAME_FILE;
            const fileAdded = await this.fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(bodyObj)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileAdded;
        } catch (err) {
            console.log(err);
        }
    }

    async deleteFileForLeads(body) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.DELETE_FILE_STORAGE_FOR_LEADS;
            const fileDeleted = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            })
            .then(data => data.json())
            .then(data => {
                if(data.error !== undefined){
                    if(data.error === 'Session Expired') {
                        let userAuthService = new UserAuthService();
                        userAuthService.logout();
                    } else {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                }
                return data;
            });

            return fileDeleted;

        } catch (err) {
            console.log(err);
        }
    }

    async getFileStorageById(fileStorageId) {
        try {
            let url = window.location.origin + this.FILE_STORAGE + this.GET_BY_ID;
            url = url
                .replace('{id}', fileStorageId);
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getFileStorageByTableAndItemId(tableType, itemId) {
        try {
            let url = window.location.origin + this.FILE_STORAGE + this.GET_BY_TABLE_AND_ITEM_ID;
            url = url
                .replace('{tableType}', tableType)
                .replace('{itemId}', itemId);
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getS3FileStorageByTableTypeAndItemId(tableType, itemId) {
        try {
            let url = window.location.origin + this.FILE_STORAGE + this.GET_S3_FILES_BY_TABLE_AND_ITEM_ID;
            url = url
                .replace('{tableType}', tableType)
                .replace('{itemId}', itemId);
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getFileClobByFileNameAndTableAndItemId(fileName, tableType, itemId) {
        try {
            let url = window.location.origin + this.FILE_STORAGE + this.GET_FILE_BY_FILENAME_AND_TABLE_AND_ITEM_ID;
            url = url
                .replace('{fileName}', fileName)
                .replace('{tableType}', tableType)
                .replace('{itemId}', itemId);
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async addFileToFileStorage(bodyObj) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.ADD_FILE_IN_STORAGE;
            const fileAdded = await this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(bodyObj)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileAdded;
        } catch (err) {
            console.log(err);
        }
    }

    async addFileToFileStorageAndGenerateUrl(bodyObj) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.ADD_FILE_AND_GENERATE_URL;
            const fileAdded = await this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(bodyObj)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileAdded;
        } catch (err) {
            console.log(err);
        }
    }

    async getPublicUrlAndUploadExistingFileClobToS3(fileMap) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.GET_AND_UPLOAD_EXISTING_FILE_IN_S3;
            const fileDataRet = await this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(fileMap)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getCompressedFileById(id) {
        try {
            let url = window.location.origin + this.FILE_CLOB + this.COMPRESSED_FILE_BY_ID;
            url = url
                .replace('{id}', id)
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async deleteFileFromFileStorage(fileName, tableType, itemId) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.DELETE_FILE_IN_STORAGE;
            let body = {
                'fileName': fileName,
                'tableType': tableType,
                'itemId': itemId
            }
            const fileDeleted = await this.fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDeleted;
        } catch (err) {
            console.log(err);
        }
    }

    async deleteFileFromFileStoragePermanent(bodyObj) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_STORAGE + this.DELETE_FILE_IN_STORAGE_PERMANENT;
            const fileDeleted = await this.fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(bodyObj)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDeleted;
        } catch (err) {
            console.log(err);
        }
    }

    async deleteFileById(id) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.FILE_CLOB + this.DELETE_FILE_BY_ID;
            let body = {
                'id': id
            }
            const fileDeleted = await this.fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDeleted;
        } catch (err) {
            console.log(err);
        }
    }
}

export default FileService;
